export const painPoints: string[] = [
  'Pierdes tiempo buscando en libros técnicos de 400 páginas durante o entre sesiones.',
  'Improvisas la combinación de puntos porque no tienes protocolos maestros a mano.',
  'Tus pacientes no entienden qué punto les estás trabajando ni por qué.',
  'Cada sesión depende de tu memoria, sin un sistema visual de respaldo preciso.',
  'Tus sesiones no tienen la presentación profesional y premium que merecen.',
  'No tienes un sistema visual que integre aguja, moxa y digitopuntura.',
]
